import { render, staticRenderFns } from "./v-order-submit-pills.vue?vue&type=template&id=639cf37a"
import script from "./v-order-submit-pills.vue?vue&type=script&lang=js"
export * from "./v-order-submit-pills.vue?vue&type=script&lang=js"
import style0 from "./v-order-submit-pills.vue?vue&type=style&index=0&id=639cf37a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports